import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import hero from "./images/hero.mp4";

const Hero: React.FC = () => {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Video background works on mobile + desktop */}
      <video
        className="absolute inset-0 h-full w-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        disablePictureInPicture
        controlsList="nodownload nofullscreen noremoteplayback"
      >
        <source src={hero} type="video/mp4" />
      </video>

      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-black/20" />

      {/* Content */}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="font-heading text-samCream mb-4 text-4xl sm:text-5xl md:text-6xl lg:text-7xl"
        >
          Taste the Legacy.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 1 }}
          className="font-body text-samCream/90 max-w-2xl text-base sm:text-lg md:text-xl"
        >
          Crafted with passion, brewed with heritage.
        </motion.p>

        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          transition={{ type: "spring", stiffness: 200 }}
          className="mt-8"
        >
          <Link
            to="/about"
            className="rounded-full bg-samAmber px-8 py-3 font-bold text-samBlue transition-all hover:bg-samCream inline-block"
          >
            Learn More
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
